module.exports = __webpack_public_path__ + "img/cashback.5319751f.svg";